import React, { PropsWithChildren, useEffect } from "react";
import { AppRoutes } from "src/app/navigation/routes";
import { NavLink, useNavigate } from "react-router-dom";
import { Nav, NavItem } from 'reactstrap';
import NurseryLayout from "src/app/layouts/NurseryLayout";
import { ChildrenStoreData } from "src/shared/types/src";
import { useAppSelector } from "src/app/services/store";
import { getCurrentChild } from "src/shared/redux-state/src";
import { checkIsEylogOnlyNursery } from "src/app/utilities/helpers";

type MessagesBaseScreenProps = {
    showFilter?: boolean
}

const MessagesBaseScreen: React.FC<PropsWithChildren<MessagesBaseScreenProps>> = ({ children, showFilter }) => {
    const navigate = useNavigate();
    const currentChild: ChildrenStoreData = useAppSelector(getCurrentChild);

    useEffect(() => {
        if (checkIsEylogOnlyNursery(currentChild)) {
            navigate(AppRoutes.EYLOG_MESSAGES);
        };
    }, [currentChild.childInstanceKey]);
    return (
        <NurseryLayout fixedFooter={true} showFilter={showFilter}>
            <div className="custom-tab custom-tab-two">
                <Nav>

                    <NavItem>
                        <NavLink to={AppRoutes.CONVERSATIONS}
                            className={({ isActive }) => (isActive
                                ? 'active text-decoration-none d-block fs-12 fw-bold text-primary'
                                : 'text-gray-300 text-decoration-none d-block fs-12 fw-regular')}>
                            Conversations
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink to={AppRoutes.COMMUNICATIONS}
                            className={({ isActive }) => (isActive
                                ? 'active text-decoration-none d-block fs-12 fw-bold text-primary'
                                : 'text-gray-300 text-decoration-none d-block fs-12 fw-regular')}>
                            Communications
                        </NavLink>
                    </NavItem>
                </Nav>
            </div>
            {children}
        </NurseryLayout>
    )
}

export default MessagesBaseScreen;